// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import { createStore } from './store'
import { createRouter } from './router'
import './style/global.less';
import common from './utils/common.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)
Vue.use(common);

Vue.config.productionTip = false

const ElementUI = require('element-ui')
require('element-ui/lib/theme-chalk/index.css')
Vue.use(ElementUI)

const Vant = require('vant')
require('vant/lib/index.css')
Vue.use(Vant);


// const VConsole = require('vconsole')
// // 初始化 vConsole 实例
// new VConsole()

// const store = createStore()
const router = createRouter()
router.beforeEach((to, from, next) => {
  // let link = document.querySelector('link[rel*="canonical"]');
	// link.href = window.location.origin + to.path;
  //window.document.title = to.meta.title;
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js